import { getLists, getAgentsByList, getAllContacts } from "../list-manager/api";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

export const getListsByAgent = async (
  agent_id: number | null | undefined
): Promise<(List & { total_overdue: number })[] | undefined> => {
  if(!agent_id) return
  const lists = await getLists({ include_archived: false });

  const results = await Promise.all(
    lists.map(async (list) => {
      try {
        const agents = await getAgentsByList(list.id);
        const isAgentInList = agents.some((agent) => agent.id === agent_id);
        if (!isAgentInList) return null;

        const contacts = await getAllContacts(list.id);
        const activeContacts = contacts.filter(
          (c: Contact) => !c.assignment_end,
        );

        const totalOverdue = activeContacts.reduce(
          (sum: number, c: Contact) => {
            const val = c.overdue_balance;
            return typeof val === "number" && !isNaN(val) ? sum + val : sum;
          },
          0,
        );

        return {
          ...list,
          total_overdue: totalOverdue,
        };
      } catch (err) {
        console.error(`Error processing list ${list.id}`, err);
        return null;
      }
    })
  );

  return results.filter(
    (list): list is List & { total_overdue: number } => list !== null
  );
};

export const useListsByAgent = ({agent_id}: {agent_id: number | null | undefined}) => {
    return useQuery({
        queryKey: ["lists-by-agent", agent_id],
        queryFn: () => getListsByAgent(agent_id),
        enabled: !!agent_id,
    })
};

const postListPriority = async (body: PostListPriorityBody) => {
  return new Promise((res) => {
    setTimeout(() => res({ message: "success" }), 1000);
  });
};

export const useListPriorityMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postListPriority,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["lists-by-agent"] });
    },
  });
};
